import React, { FormEvent, useState, useContext, useEffect } from "react";
import AuthContext from "../../../contexts/AuthContext";
import { RouteProps } from "react-router-dom";

import Input from "../../../components/Form/Input";
import Button from "../../../components/Form/Button";

import { SimpleResponse } from "../../../services/api/Request";
import Plan, { IPlan, IChannel } from "../../../services/api/Plan";
import { SetModal } from "../../../components/Modal";
import WeekPeriod from "../../../services/api/WeekPeriod";

interface FormProps extends RouteProps {
  sale: IPlan;
  month: number;
  year: number;
}

const Form: React.FC<FormProps> = ({ sale, month, year }) => {
  const { user } = useContext(AuthContext);
  const readOnly = user!.profile.name === "Viewer";
  const [response, setResponse] = useState<SimpleResponse>();
  const isUpdate = sale && sale.id;
  const [weekPeriod, setWeekPeriod] = useState<boolean>(false);
  useEffect(() => {
    Promise.all([WeekPeriod.GetPlan()])
      .then((value) => {
        const day = new Date().getDate();
        setWeekPeriod(day >= value[0].startDateW1 && day <= value[0].endDateW1);
      })
      .catch(() => undefined);
  }, []);


  async function handleFormSubmit(event: FormEvent) {
    event.preventDefault();
    const formData: FormData = new FormData(event.target as HTMLFormElement);
    let data: any = {
      groupId: sale.groupId,
      channels: []
    };

    formData.forEach((value: FormDataEntryValue, key: string) => {
      if (key.indexOf("channel") === -1) data[key] = value ? value : 0;
    });

    sale.channels.forEach((value: IChannel, key: number) => {

      const elName: string = "channel" + value.channelId;
      const BP: string | null = normalizeNumber(formData.get(elName + "[planBusinessPlan]"));
      const FRE: string | null = normalizeNumber(formData.get(elName + "[planFRE]"));
      const SRE: string | null = normalizeNumber(formData.get(elName + "[planSRE]"));

      data["channels"].push({
        channelId: value.channelId,
        channelTypeName: value.channelTypeName,
        id: value.id,
        planBusinessPlan: BP ? BP : 0,
        planFRE: FRE ? FRE : 0,
        planSRE: SRE ? SRE : 0,
        previousDate: value.previousDate,
        currentDate: value.currentDate
      });
    });

    const response: SimpleResponse = await (isUpdate
      ? Plan.Update(sale.id, data)
      : Plan.Create(year, month, data));

    setResponse(response);
  }

  function normalizeNumber(value: FormDataEntryValue | null) {
    return value === null ? null : (value + "").replace(/\./g, '');
  }

  function list(obj: any): any {
    return (
      <div className="form form--border" key={`${obj.channelName} (${obj.channelTypeName})`}>
        <h3 className="form__title">{`${obj.channelName} (${obj.channelTypeName})`}</h3>
        <div className="form__fields--sideBySide">
          <Input
            masked={true}
            disabled={readOnly || !weekPeriod}
            name={"channel" + obj.channelId + "[planBusinessPlan]"}
            title="Business Plan"
            value={obj.planBusinessPlan}
            type="number"
          />
          <Input
            masked={true}
            disabled={readOnly || !weekPeriod}
            name={"channel" + obj.channelId + "[planFRE]"}
            title="FRE"
            value={obj.planFRE}
            type="number"
          />
          <Input
            masked={true}
            disabled={readOnly || !weekPeriod}
            name={"channel" + obj.channelId + "[planSRE]"}
            title="SRE"
            value={obj.planSRE}
            type="number"
          />
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      {response ? SetModal.FromResponse(response, () => {
        setResponse(undefined);
        if (response.status === 200) {
          //history.push({ pathname: "/empty" });
          //history.goBack();
        }
      }) : null}
      <form
        className="container details__forms form__group-container"
        onSubmit={handleFormSubmit}
      >
        {sale.channels.map(list)}

        <div></div>
        <Button
          disabled={readOnly}
          className="button button--big button--blue details__button--form"
          title={isUpdate ? "Save" : "Send"}
        />
      </form>
    </React.Fragment>
  );
};

export default Form;
